const files = require.context(".", true, /ExcelUpload\.vue$/);

const modules = {};

files.keys().forEach((key) => {
  modules[key.toLowerCase().replace(/(\.\/|\.vue)/g, "").replace("/", "_")] = files(key).default;
});

export default modules;
